registerGlobal( 'PlatformEmscripten' );

PlatformEmscripten.GetDeviceModel = function() {
    return platform.name + " on " + platform.os;
}

PlatformEmscripten.GetOsVersion = function() {
    return String(platform.version);
}

PlatformEmscripten.localStorageSet = function(key, value) {
    try {
        window.localStorage.setItem(key, value);
    } catch(e){}
}

PlatformEmscripten.localStorageGet = function(key) {
    try {
        return window.localStorage.getItem(key);
    } catch(e){}
    return null;
}



//////////////////
// WEBPACK FOOTER
// /src/src/platform/emscripten/Application.platform.js
// module id = 24
// module chunks = 0